export default __webpack_public_path__ + "static/media/arrow.a0173837.svg";